export function _performanceMark(name: string): void {
    if (!performance || !performance.mark) {
        return;
    }
    performance.mark(name);
}
